import { type CSSProperties, type PropsWithChildren } from 'react';

import { Title } from '@/components/typography';
import PageMetadata from '@/hooks/page/PageMetadata';
import { cn } from '@/lib/utils';

type PageProps = {
  className?: string;
  title?: string;
  pageName?: string;
  exampleAIQuestions: string[];
  style?: CSSProperties;
  noPadding?: boolean;
};

const Page = ({
  className = '',
  title,
  pageName,
  exampleAIQuestions,
  children,
  style = {},
  noPadding = false,
  ...rest
}: PropsWithChildren<PageProps>) => {
  const pageTitle = title ? `${title}${pageName != null ? ` - ${pageName}` : ''}` : null;

  return (
    <div
      id="pageRoot"
      {...rest}
      className={cn(
        'relative flex flex-1 flex-col gap-6',
        noPadding ? 'p-0' : 'px-8 py-6 max-sm:px-4',
        className,
      )}
      style={style}
    >
      {pageTitle && (
        <>
          <PageMetadata exampleAIQuestions={exampleAIQuestions ?? []}>{pageTitle}</PageMetadata>
          <Title
            level={1}
            className={cn('shrink-0 wrap-break-word', noPadding && 'mx-8 mt-6 max-sm:mx-4')}
          >
            {pageTitle}
          </Title>
        </>
      )}
      {children}
    </div>
  );
};

export default Page;
